import { useTranslation } from 'react-i18next'
import Lottie from 'react-lottie'
import classNames from 'classnames'
import aiLogo from '../../../../assets/ai_logo.svg'
import watsonAssistant from '../../../../utils/watson-assistant'
import * as animationData from '../../../../assets/animations/hotspot.json'
import './styles.scss'
import { VIRTUAL_TOUR_EVENT } from '../../constant'

const Hotspot = ({ hotspot }) => {
  const { t } = useTranslation()

  return (
    <div
      className={classNames({
        'tour-image-hotspot': true,
        [`position-${hotspot.position}`]: true,
      })}
      style={{ left: `${hotspot.x}%`, top: `${hotspot.y}%` }}
    >
      <div className={'test'}>
        <div
          className="tour-image-label"
          onClick={() => {
            watsonAssistant.getInstance().sendMessageHotspot(t(hotspot?.message))
            const event = new CustomEvent('assistant-overlay', {
              detail: { mode: VIRTUAL_TOUR_EVENT.HOTSPOT },
            })
            document.body.dispatchEvent(event)
          }}
        >
          <img
            src={aiLogo}
            alt="AI logo"
          />
          {t(hotspot.label)}
        </div>
        <div
          className={classNames({
            'vertical-line': ['top', 'bottom'].includes(hotspot.position),
            'horizontal-line': ['left', 'right'].includes(hotspot.position),
          })}
        />
      </div>
      <div
        className={classNames({
          'tour-image-spot': true,
          [`spot-position-${hotspot.position}`]: true,
        })}
        onClick={() => {
          watsonAssistant.getInstance().sendMessageHotspot(t(hotspot?.message))
          const event = new CustomEvent('assistant-overlay', {
            detail: { mode: VIRTUAL_TOUR_EVENT.HOTSPOT },
          })
          document.body.dispatchEvent(event)
        }}
      >
        <Lottie
          isClickToPauseDisabled
          options={{
            loop: true,
            autoplay: true,
            animationData: animationData,
          }}
        />
      </div>
    </div>
  )
}

export default Hotspot
